module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 2560 / 360
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.settings.header
    }
  }, [_c('v-card-title', [_vm._v("\n                Header\n                "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Ideal: 2560px x 360px")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "2"
    }
  }, [_c('v-card', [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1 / 1
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.settings.logo
    }
  }, [_c('v-card-title', [_vm._v("Logo")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Ideal: 500px x 500px")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-row', {
    staticClass: "pa-2 pt-4"
  }, [_c('v-card-title', [_vm._v("Webadressen")]), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Mitglied",
      "label": "Bezeichnung Mitglied (Einzahl)"
    },
    model: {
      value: (_vm.settings.bezMitglieder1),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezMitglieder1", $$v)
      },
      expression: "settings.bezMitglieder1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Mitglieder",
      "label": "Bezeichnung Mitglieder"
    },
    model: {
      value: (_vm.settings.bezMitglieder),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezMitglieder", $$v)
      },
      expression: "settings.bezMitglieder"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Vorstand",
      "label": "Bezeichnung Vorstand (Einzahl)"
    },
    model: {
      value: (_vm.settings.bezVorstand1),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezVorstand1", $$v)
      },
      expression: "settings.bezVorstand1"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Vorstand",
      "label": "Bezeichnung Vorstand"
    },
    model: {
      value: (_vm.settings.bezVorstand),
      callback: function($$v) {
        _vm.$set(_vm.settings, "bezVorstand", $$v)
      },
      expression: "settings.bezVorstand"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "justify-center pa-1 pl-2",
    style: ('background-color:' + _vm.settings.primary),
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Primärfarbe")]), _vm._v(" "), _c('v-color-picker', {
    model: {
      value: (_vm.settings.primary),
      callback: function($$v) {
        _vm.$set(_vm.settings, "primary", $$v)
      },
      expression: "settings.primary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "justify-center pa-1 pl-2",
    style: ('background-color:' + _vm.settings.secondary),
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Sekundärfarbe")]), _vm._v(" "), _c('v-color-picker', {
    model: {
      value: (_vm.settings.secondary),
      callback: function($$v) {
        _vm.$set(_vm.settings, "secondary", $$v)
      },
      expression: "settings.secondary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "justify-center pa-1 pl-2",
    style: ('background-color:' + _vm.settings.tertiary),
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v("Tertiärfarbe")]), _vm._v(" "), _c('v-color-picker', {
    model: {
      value: (_vm.settings.tertiary),
      callback: function($$v) {
        _vm.$set(_vm.settings, "tertiary", $$v)
      },
      expression: "settings.tertiary"
    }
  })], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-title', [_vm._v("Neue Bilder hochladen")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Lade die Bilder idealerweise als .webp-Datei hoch.")]), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "loading": _vm.loading.logo,
      "outlined": "",
      "dense": "",
      "label": "Logo (500px x 500px)"
    },
    on: {
      "change": function($event) {
        return _vm.uploadLogo()
      }
    },
    model: {
      value: (_vm.selectPicture.logo),
      callback: function($$v) {
        _vm.$set(_vm.selectPicture, "logo", $$v)
      },
      expression: "selectPicture.logo"
    }
  }), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "loading": _vm.loading.header,
      "outlined": "",
      "dense": "",
      "label": "Header (1920px x 300px)"
    },
    on: {
      "change": function($event) {
        return _vm.uploadHeader()
      }
    },
    model: {
      value: (_vm.selectPicture.header),
      callback: function($$v) {
        _vm.$set(_vm.selectPicture, "header", $$v)
      },
      expression: "selectPicture.header"
    }
  }), _vm._v(" "), _c('v-file-input', {
    attrs: {
      "loading": _vm.loading.background,
      "outlined": "",
      "dense": "",
      "label": "Login-Background-Bild (1920px x 1080px)"
    },
    on: {
      "change": function($event) {
        return _vm.uploadBackground()
      }
    },
    model: {
      value: (_vm.selectPicture.background),
      callback: function($$v) {
        _vm.$set(_vm.selectPicture, "background", $$v)
      },
      expression: "selectPicture.background"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-1",
    attrs: {
      "cols": "4"
    }
  }, [_c('v-card', [_c('v-responsive', {
    attrs: {
      "aspect-ratio": 1920 / 1080
    }
  }, [_c('v-img', {
    attrs: {
      "src": _vm.settings.background
    }
  }, [_c('v-card-title', [_vm._v("Background")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("Ideal: 1920px x 1080px")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-title', [_vm._v("Hauptmenü Einträge")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Veranstaltungen"
    },
    model: {
      value: (_vm.settings.showMenuVeranstaltungen),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuVeranstaltungen", $$v)
      },
      expression: "settings.showMenuVeranstaltungen"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Kontakte"
    },
    model: {
      value: (_vm.settings.showMenuKontakte),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuKontakte", $$v)
      },
      expression: "settings.showMenuKontakte"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Rechnungen"
    },
    model: {
      value: (_vm.settings.showMenuRechnungen),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuRechnungen", $$v)
      },
      expression: "settings.showMenuRechnungen"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Kontaktdaten"
    },
    model: {
      value: (_vm.settings.showMenuKontaktdaten),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuKontaktdaten", $$v)
      },
      expression: "settings.showMenuKontaktdaten"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Download"
    },
    model: {
      value: (_vm.settings.showMenuDownload),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuDownload", $$v)
      },
      expression: "settings.showMenuDownload"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Semester"
    },
    model: {
      value: (_vm.settings.showMenuSemester),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuSemester", $$v)
      },
      expression: "settings.showMenuSemester"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Stammbaum"
    },
    model: {
      value: (_vm.settings.showMenuStammbaum),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showMenuStammbaum", $$v)
      },
      expression: "settings.showMenuStammbaum"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card-title', [_vm._v("Startseite Widgets")]), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Veranstaltungen"
    },
    model: {
      value: (_vm.settings.showWidgetVeranstaltungen),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetVeranstaltungen", $$v)
      },
      expression: "settings.showWidgetVeranstaltungen"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Suche"
    },
    model: {
      value: (_vm.settings.showWidgetSuche),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetSuche", $$v)
      },
      expression: "settings.showWidgetSuche"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Updates"
    },
    model: {
      value: (_vm.settings.showWidgetUpdates),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetUpdates", $$v)
      },
      expression: "settings.showWidgetUpdates"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Geburtstagsliste"
    },
    model: {
      value: (_vm.settings.showWidgetGeburtstagsliste),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetGeburtstagsliste", $$v)
      },
      expression: "settings.showWidgetGeburtstagsliste"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Anzahl Mitglieder"
    },
    model: {
      value: (_vm.settings.showWidgetMitglieder),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetMitglieder", $$v)
      },
      expression: "settings.showWidgetMitglieder"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Chargen Aktivitas"
    },
    model: {
      value: (_vm.settings.showWidgetChargen1),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetChargen1", $$v)
      },
      expression: "settings.showWidgetChargen1"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Chargen AHV"
    },
    model: {
      value: (_vm.settings.showWidgetChargen2),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetChargen2", $$v)
      },
      expression: "settings.showWidgetChargen2"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "py-0 my-0",
    attrs: {
      "dense": "",
      "label": "Chargen HBV"
    },
    model: {
      value: (_vm.settings.showWidgetChargen3),
      callback: function($$v) {
        _vm.$set(_vm.settings, "showWidgetChargen3", $$v)
      },
      expression: "settings.showWidgetChargen3"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1ee8898"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/einstellungenComponents/Design.vue
// module id = 818
// module chunks = 15